import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Resumecontent from "./ResumeContent";
import axios from "axios";
import pdf from "../../Assets/vinuri-piyathilake.pdf";
import { AiOutlineDownload } from "react-icons/ai";

function Resume() {
  const uri = "https://porfolio-backend.vercel.app/ranks/getRanks";
  const [spojRank, upadteSpojRank] = useState(0);
  const [hackerrank, upadteHackerank] = useState(0);
  const [sem, upadateSem] = useState(0);
  const [cgpa, upadteCgpa] = useState(0);
  const link = "https://www.cloudskillsboost.google/public_profiles/f0bbbabd-30b1-40b3-aadf-3d4c1240c87f";

  useEffect(() => {
    axios
      .get(uri)
      .then((res) => {
        upadteSpojRank(res.data.message[0].spojRank);
        upadteHackerank(res.data.message[1].hackerrank);
        upadteCgpa(res.data.message[2].cgpa);
        upadateSem(res.data.message[3].sem);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Container fluid className="resume-section">
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
			{/*<Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
			</Button>*/}
        </Row>
        <Row className="resume">
     
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="University of Colombo School of Computing (UCSC)"
              date="Jan. 2019 - May 2023"
              content={[`BSc (Hons) in Information Systems`]}
            />
          
            <Resumecontent
              title="IJSE – Institute of Software Engineering"
              date="Feb 2021 - Feb 2022"
              content={[`Diploma, Comprehensive Master Java Developer`]}
            />

{/* <Resumecontent
              title="Open University of Sri Lanka"
              date="Jan 2019 - Present"
              content={[`LLB, Bachelor of Laws`]}
            /> */}

<Resumecontent
              title="University of Colombo"
              date="Jan 2019 - May 2022"
              content={[`Diploma, Advanced English for Administration and Academic Purposes (DAE)`]}
            />
            
                 <Resumecontent
              title="Sirimavo Bandaranaike Vidyalaya, Colombo 07"
              date="2008 – 2017"
              content={[`Secondary Education (Bio Science)`]}
             
            />
            <h3 className="resume-title">Achievements</h3>
            <Resumecontent
              title="ARIMAC FUTURECAST"
              content={[
                `Finalists | 2021`,
                `Inter University Hackathon organized by Arimac Lanka in collaboration with
                AIESEC Sri Lanka.`,
                `Team VANiSH was selected as one of the top five finalists in the Immersive Technology Category.`
              ]}
/>
<Resumecontent
              title="Hackaholics 4.0"
              content={[
                `Finalists | 2021`,
                `Inter University Girls-Only Hackathon organized by the IEEE WIE Student Branch Affinity Group of UCSC`
              ]}
/>
<Resumecontent
              title="Pre-HacktoberFest 1.0"
              content={[
                `Finalists | 2019`,
                `Intra University Open-Source Competition organized by Mozilla Club of UCSC`
              ]}
/>

<h3 className="resume-title">Awards</h3>
<Resumecontent
              title="Sampath Bank Award for the Best Final Year Research Project"
              content={[

                `Recognized with the Best Research Award in the BSc (Hons) Information Systems degree for the year-long research endeavour during the final year at the university.`
              ]}
            />

            <Resumecontent
              title="Director's List Awardee for Academic Performance"
              content={[

                `For achieving an overall GPA of 3.7/4.0 or above in the academic year 2019/2020.`
              ]}
            />

<h3 className="resume-title">Other Qualifications</h3>
<Resumecontent
              title="Comprehensive Master Java Developer"
              content={[
                `Offered by Institute of Software Engineering | Feb 2022`,
              ]}
            />
            <Resumecontent
              title="Microsoft Certified: Azure Fundamentals"
              content={[
                `Marks obtained - (871/1000) | Jun 2021`,
              ]}
            />
             {/* <Resumecontent
              title="Google Cloud Platform Fundamentals"
              content={[
                ` | 2020`,
              ]}
            /> */}
            
          </Col>
          <Col md={6} className="resume-left">
          <h3 className="resume-title">Work Experience</h3>
          <Resumecontent
              title="Research Assistant"
              date="June 2023 - Present"
              content={[
                "GeoMatics - Research Group, University of Colombo School of Computing"
              ]}
            />

          <Resumecontent
              title="Research Intern"
              date="Oct 2021 - April 2022"
              content={[
                "Signal Insights - Research Group, University of Colombo School of Computing"
              ]}
            />

           <h3 className="resume-title">Project Experience</h3>

           <Resumecontent
              title="Decentralized Heterogeneous Edge AI for Efficient Elephant Tracking"
              date="June 2022 - May 2023"
              content={[
                "The study focused on the energy-efficient operation of Eloc, a resource-constrained edge device used for elephant rumble detection in forested areas. It assessed energy consumption by contrasting on-device sound classification with sending only results to a base station via the network and transmitting the entire recorded data over the network for subsequent classification. Furthermore, the study introduced Eloc-Web, a visualization tool for mapping the estimated elephant locations based on acoustic localization, specifically accounting for the uncertainty associated with machine learning-based detection. Research Domains: Geographical Information Systems, Embedded Systems, Machine Learning, Sensor Networks",
                "Python, C/C++, FLoRA, OMNeT++, React.js, Leaflet.js",
              ]}
            />

            <Resumecontent
              title="ELOC Software"
              date="Oct 2021 - April 2022"
              content={[
                "A sound processing pipeline that would automatically detect elephant rumbles recorded by the ELOC node, which is a low-cost infrasonic detector designed to detect elephant rumbles. A novel digital signal processing approach known as Wavelet Transform is utilized for robust feature extraction and noise denoising of the elephant sounds. Domains of research focus include Digital Signal Processing, Machine Learning, Passive Acoustic Monitoring, and Embedded Systems.",
                "Python, librosa, PyWavelets, scikit-learn, TensorFlow, Keras",
              ]}
            />
            <Resumecontent
              title="Edifice"
              date="May 2021 - Oct 2021"
              content={[
                "A Construction Project Management System that construction companies can use to manage all phases and aspects of a project, from start to completion, including project management, financial management, and resource management.",
                "React.js, Node.js, Express.js, MySQL",
              ]}
            />
                   <Resumecontent
              title="GLUCO"
              date="Feb 2020 - Feb 2021"
              content={[
                "The project consists of a Web and Mobile Application for diabetes self-management, which is helpful for diabetic patients, as well as a separate web platform for diabetes data analysis for the benefit of health researchers.",
                "PHP, HTML, CSS, JavaScript, Java, SQLite, 3-Tier Architecture",
              ]}
            />

<Resumecontent
              title="Grand Stores"
              date="May 2021"
              content={[
                "A complete wholesale management system with features for managing items, customers, and orders.",
                "Java, JavaFX/Swing, SQL, Layered Architecture, Singleton Pattern, Factory Design Pattern",
              ]}
            />

<Resumecontent
              title="YoYo"
              date="Sep 2019 - Dec 2019"
              content={[
                "Online Sales & Marketing Web Application",
                "PHP, HTML, CSS, JavaScript, MySQL",
              ]}
            />


            <h3 className="resume-title">Volunteer Experience</h3>
            <Resumecontent
              title="Event Coordinator - International Career Fair | Dec 2020"
              content={[
                "AIESEC in University of Colombo",
              ]}
            />
            <Resumecontent
              title="Event Coordinator - iHack 5.0 | Oct 2019"
              content={[
                "UCSC ISACA Student Group",
              ]}
            />
            <Resumecontent
              title="Event Coordinator - The post-conference workshop for
              ICTer | Sep 2019"
              content={[
                "UCSC ISACA Student Group",
              ]}
            />
                     <Resumecontent
              title="Facilitator - Island-Wide World's Largest Lesson | 2020"
              content={[
                "AIESEC Sri Lanka",
              ]}
            />

<Resumecontent
              title="Content Creator | Sep 2019 - Dec 2021"
              content={[
                "Pahasara UCSC Student Group",
              ]}
            />

                       <Resumecontent
              title="Organizing Committee Vice President - External
              Relations - Project Culture Cart | 2020"
              content={[
                "AIESEC in University of Colombo",
              ]}
            />
                       <Resumecontent
              title="Organizing Committee Vice President - External
              Relations - Project Forte 8.0 | 2019"
              content={[
                "AIESEC in University of Colombo",
              ]}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
			{/* <Button variant="primary" href={pdf} target="_blank">
          <AiOutlineDownload />&nbsp;Download CV
			</Button>*/}
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
